import ConnectyCube from "./connectycube_init";

class AuthService {
  $callScreen = document.getElementById("call");
  credentials = null;
  sessionCreated = false;

  fetchCredentials = async () => {
    if (this.credentials) {
      return this.credentials;
    }

    try {
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

      const response = await fetch("/api/v1/connectycube/session", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json"
        },
        credentials: "same-origin"
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        const err = new Error(data.error || "Failed to get ConnectyCube credentials");
        err.isUnauthorized = response.status === 401;
        throw err;
      }

      // Server returns { ready: false } when not signed in (e.g. registration flow) — no ConnectyCube session.
      if (data.ready === false) {
        return null;
      }

      this.credentials = data;
      return this.credentials;
    } catch (error) {
      if (!error.isUnauthorized) {
        console.error("[AuthService][fetchCredentials] Error:", error);
      }
      throw error;
    }
  };

  login = async () => {
    try {
      const credentials = await this.fetchCredentials();

        // fetchCredentials() returns null when the caller isn't signed in
        // (server responds { ready: false }) — nothing to do in that case.
        if (!credentials) {
            return null;
        }

      if (!this.sessionCreated) {
        await ConnectyCube.createSession({
          login: credentials.login,
          password: credentials.password
        });
        this.sessionCreated = true;
      }

      await this.ensureChatConnected();

      console.log("[AuthService][login] Connected successfully");
      return credentials;
    } catch (error) {
      if (!error.isUnauthorized) {
        console.error("[AuthService][login] Error:", error);
      }
      throw error;
    }
  };

  ensureChatConnected = async () => {
    if (ConnectyCube.chat.isConnected) {
      return;
    }

    const credentials = await this.fetchCredentials();
    if (!credentials?.user_id) {
      return;
    }

    await ConnectyCube.chat.connect({
      userId: credentials.user_id,
      password: credentials.password
    });
  };

  logout = () => {
    ConnectyCube.chat.disconnect();
    ConnectyCube.destroySession();
    this.credentials = null;
    this.sessionCreated = false;

    if (this.$callScreen) {
      this.$callScreen.classList.add("hidden");
    }
  };

  getUserId = () => {
    return this.credentials?.user_id;
  };
}

// create instance
const Auth = new AuthService();

export default Auth;
